import React, { FC } from 'react';
import { TechAbilityEnum } from '~/src/models/enums/tech-ability.enum';
import { COLORS } from '~/src/styles/tokens/colors';
import { TechAbilitySinglePlank } from './components/tech-ability-single-plank';
import { SvgSuccessIcon } from '~/src/components/svg-components/tech-ability/success-icon';
import { SvgNoneIcon } from '~/src/components/svg-components/tech-ability/none-icon';
import { SvgError } from '~/src/components/svg-components/error';
import { SvgSpinnerIcon } from '~/src/components/svg-components/tech-ability/spinner-icon';
import * as Styled from './tech-ability-plank.styles';

interface TechAbilityPlankProps {
    isLoading: boolean;
    isError: boolean;
    onRetryTechAbility: () => void;
    techAbility?: TechAbilityEnum;
}

export const TechAbilityPlank: FC<TechAbilityPlankProps> = ({
    isError,
    isLoading,
    onRetryTechAbility,
    techAbility,
}) => {
    const renderContent = () => {
        if (isLoading) {
            return (
                <TechAbilitySinglePlank
                    hasSpinner
                    icon={<SvgSpinnerIcon />}
                    text="Проверка технической возможности подключения по этому адресу"
                />
            );
        }

        if (isError) {
            return (
                <>
                    <TechAbilitySinglePlank
                        icon={<SvgNoneIcon />}
                        text="Проверьте возможность подключения по этому адресу позже"
                    />
                    <Styled.RetryTechAbilityButton onClick={onRetryTechAbility}>
                        Повторить проверку
                    </Styled.RetryTechAbilityButton>
                </>
            );
        }

        switch (techAbility) {
            case TechAbilityEnum.FIXED:
                return (
                    <TechAbilitySinglePlank
                        icon={<SvgSuccessIcon />}
                        text="Доступно подключение только проводного интернета"
                    />
                );
            case TechAbilityEnum.MOBILE:
                return <TechAbilitySinglePlank icon={<SvgSuccessIcon />} text="Доступно подключение 3G/LTE" />;
            case TechAbilityEnum.BOTH:
                return (
                    <TechAbilitySinglePlank
                        icon={<SvgSuccessIcon />}
                        text="Доступно подключение проводного интернета или 3G/LTE"
                    />
                );
            case TechAbilityEnum.NONE:
                return <TechAbilitySinglePlank icon={<SvgNoneIcon />} text="Подключение по этому адресу невозможно" />;
            case TechAbilityEnum.REFINEMENT_FIXED_ONLY:
                return (
                    <TechAbilitySinglePlank
                        icon={<SvgError fill={COLORS.accentWarning} />}
                        text="Уточните доступность подключения у менеджера"
                    />
                );
            case TechAbilityEnum.REFINEMENT_WITH_MOBILE:
                return (
                    <>
                        <TechAbilitySinglePlank icon={<SvgSuccessIcon />} text="Доступно подключение 3G/LTE" />
                        <TechAbilitySinglePlank
                            icon={<SvgError fill={COLORS.accentWarning} />}
                            text="Уточните возможность подключения проводного интернета у менеджера"
                        />
                    </>
                );
            default:
                return null;
        }
    };

    return <Styled.TechAbilityPlankContainer>{renderContent()}</Styled.TechAbilityPlankContainer>;
};
